import React, {useRef} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../styles/campaign.scss';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';

function Campaign() {
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };
    const slides = [
        { image: '/images/Campaign/Fonzies.png', title: "Spot Fonzies x Kings League", description: "" ,  className: "fonzies"},
        { image: '/images/Campaign/LeoPizzo.png', title: "Leo Pizzo", description: "",  className: "leo-pizzo" },
        { image: '/images/Campaign/1.jpg', title: "MOTOROLA RAZR50 ULTRA", description: "" },
        { image: '/images/Campaign/2.jpg', title: "A-MORE X BENEFIT", description: "" },
        { image: '/images/Campaign/3.jpg', title: "BIGOODINO", description: "" },
        { image: '/images/Campaign/4.jpg', title: "HINNOMINATE", description: "" },
        { image: '/images/Campaign/5.jpg', title: "DOPPIAA", description: "" },
        { image: '/images/Campaign/6.jpg', title: "11  F/W 24/25", description: "" },
        { image: '/images/Campaign/5Progress.jpg', title: "5 PROGRESS F/W 24/25", description: "" },
        { image: '/images/Campaign/coppola.jpeg', title: "Marco Coppola FW25", description: "" }
    ];
    return (
        <div className="containerGallery">
          <Swiper
        slidesPerView="auto"
        spaceBetween={40}
        centeredSlides={true}
        grabCursor={true}
        loop={true}
        modules={[Navigation, Pagination, EffectCoverflow,Autoplay]}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        effect="coverflow"
        coverflowEffect={{
          rotate: 10,
          stretch: 0,
          depth: 100,
          modifier: 1.2,
          slideShadows: false,
        }}
        pagination={{ clickable: true }}
        navigation={false} /* Disabilito i button*/
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        breakpoints={{
          300: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1850: {
            slidesPerView: 4.5,
            spaceBetween: 25,
          },
          1920: {
            slidesPerView: 4,
            spaceBetween: 100,

          }
        }}
      > 
         {slides.map((slide, index) => (
           <SwiperSlide key={index} className="swiper-slide-campaign">
             <div className="swiper-slide-content-campaign">
               <img src={slide.image} alt={slide.title} className={`swiper-slide-image-campaign ${slide.className || ""}`}/>
               <div className="swiper-slide-textbox-campaign">
                 <p className="swiper-text-large-campaign">{slide.title}</p>
                 <p className="swiper-text-small-campaign">{slide.description}</p>
               </div>
             </div>
           </SwiperSlide>
         ))}
         <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
       </Swiper>
     </div>
    );
}
export default Campaign;